import React, { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { FilterPontosVenda } from '../../redux/actions/PontoVenda';

import './index.scss';

const Filter: React.FC = () => {
  const dispatch = useDispatch();
  const refNome = useRef<HTMLInputElement>(null);

  const handleFilterPontosVenda = (filter: string) => {
    const typeFilter = refNome.current?.checked ? 'N' : 'C';
    dispatch(FilterPontosVenda(filter, typeFilter));
  };

  const handleChange = useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>) => {
      handleFilterPontosVenda(ev.target.value);
    },
    [],
  );

  return (
    <div id="Filter-Container">
      <span>Filtrar por</span>
      <div id="Container-Busca">
        <div className="OpcoesBusca">
          <input
            ref={refNome}
            type="radio"
            value="0"
            name="opcaoBusca"
            defaultChecked={true}
          />
          <span>Nome</span>
        </div>

        <div className="OpcoesBusca">
          <input type="radio" value="1" name="opcaoBusca" />
          <span>CNPJ</span>
        </div>

        <input
          id="editBusca"
          type="text"
          name="frmbusca"
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default Filter;
